"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "ma-block" };
const _hoisted_2 = {
    key: 0,
    class: "ma-player"
};
const _hoisted_3 = ["title"];
const _hoisted_4 = {
    key: 0,
    class: "ma-scores player_home_block--milestones-and-awards-scores"
};
const _hoisted_5 = ["textContent"];
const _hoisted_6 = ["textContent"];
const _hoisted_7 = {
    key: 1,
    class: "ma-description"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.milestone.playerName)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.createElementVNode)("i", {
                    title: _ctx.milestone.playerName,
                    class: (0, vue_1.normalizeClass)(["board-cube", `board-cube--${_ctx.milestone.color}`])
                }, null, 10, _hoisted_3)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(["ma-name--milestones", _ctx.nameCss])
        }, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.name), 1)
            ])), [
                [_directive_i18n]
            ]),
            (_ctx.showScores)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.sortedScores, (score) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, {
                            key: score.color
                        }, [
                            (_ctx.playerSymbol(score.color).length > 0)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("p", {
                                    key: 0,
                                    class: (0, vue_1.normalizeClass)(["ma-score", `player_bg_color_${score.color}`]),
                                    textContent: (0, vue_1.toDisplayString)(_ctx.playerSymbol(score.color)),
                                    "data-test": "player-score"
                                }, null, 10, _hoisted_5))
                                : (0, vue_1.createCommentVNode)("", true),
                            (0, vue_1.createElementVNode)("p", {
                                class: (0, vue_1.normalizeClass)(_ctx.getClass(score)),
                                textContent: (0, vue_1.toDisplayString)(score.score),
                                "data-test": "player-score"
                            }, null, 10, _hoisted_6)
                        ], 64));
                    }), 128))
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ], 2),
        (_ctx.showDescription)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.description), 1)
                ])), [
                    [_directive_i18n]
                ])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
